var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgEye = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M15.965 7.25c-6.74 0-10.3 5.53-11.468 7.76a2.14 2.14 0 0 0-.01 1.978c1.158 2.256 4.677 7.762 11.478 7.762 6.74 0 10.3-5.53 11.468-7.76.326-.62.33-1.353.01-1.978-1.158-2.256-4.677-7.762-11.478-7.762m-10.14 8.456c1.131-2.16 4.314-6.956 10.14-6.956 5.889 0 9.029 4.775 10.143 6.947a.64.64 0 0 1-.003.597c-1.131 2.16-4.313 6.956-10.14 6.956-5.889 0-9.029-4.775-10.143-6.947a.64.64 0 0 1 .003-.597M12.75 16A3.25 3.25 0 0 1 16 12.75 3.25 3.25 0 0 1 19.25 16 3.25 3.25 0 0 1 16 19.25 3.25 3.25 0 0 1 12.75 16M16 11.25A4.75 4.75 0 0 0 11.25 16 4.75 4.75 0 0 0 16 20.75 4.75 4.75 0 0 0 20.75 16 4.75 4.75 0 0 0 16 11.25",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEye);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };